import { BuildingIcon } from "lucide-react";
import { twMerge } from "tailwind-merge";

const EstablishmentMapHeader = () => {
  return (
    <div className={twMerge(
      'flex items-center justify-between p-3 w-[386px] rounded',
    )}>
      <div className="flex gap-2 items-center">
        <BuildingIcon className="w-10 h-10" strokeWidth={1.5} />

        <h2 className="text-2xl font-bold">
          Rede credenciada
        </h2>
      </div>
    </div>
  );
};

export default EstablishmentMapHeader;
